import { BookOpen } from 'lucide-react'
import type { Integration } from '@/types/integration'

export const knowledgeHubIntegration: Integration = {
  id: 'knowledge-hub',
  name: 'Knowledge Hub',
  shortName: 'KH',
  icon: BookOpen,
  enabled: true,
  configured: true,
  color: 'blue',
  description: 'Document lifecycle review queue and changelog',
}

export { KnowledgeHubWorkspaceNavRow } from './knowledge-hub-workspace-nav-row'
